module.exports = __webpack_public_path__ + "static/media/20ECE29.3c9a5348.jpg";